var map = {
	"./assets/mesh/largeCenterCup.json": 133
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 132;



//////////////////
// WEBPACK FOOTER
// ./app ./~/file-loader?name=data/[name].json!^\.\/.*\/largeCenterCup\.json$
// module id = 132
// module chunks = 0